module.exports = __webpack_public_path__ + "static/media/branding.0bfefe36.svg";